/**
 * Dialogue de confirmation modal.
 */

import React, { useEffect } from "react";
import "./ConfirmDialog.css";

/**
 * Affiche une boîte de dialogue de confirmation.
 * @param {Object} props
 * @param {string} props.message - Message à afficher.
 * @param {Function} props.onConfirm - Callback de confirmation.
 * @param {Function} props.onCancel - Callback d'annulation.
 */
export default function ConfirmDialog({ message, onConfirm, onCancel }) {
  // Echap annule, au meme titre que le tap hors du dialogue
  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === "Escape") onCancel();
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onCancel]);

  return (
    <div className="confirm-overlay" onClick={onCancel} role="presentation">
      {/* stopPropagation : un tap dans le dialogue ne doit pas l'annuler */}
      <div
        className="confirm-box"
        role="alertdialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <p>{message}</p>
        <div className="confirm-actions">
          <button onClick={onCancel} className="btn btn-secondary">
            Annuler
          </button>
          <button onClick={onConfirm} className="btn btn-danger">
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
}
